import {rankWith,isDateControl} from '@jsonforms/core';
export default rankWith(10, isDateControl);